module.exports = __webpack_public_path__ + "static/media/bac.fd741770.jpg";